/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import t from 'prop-types';

var EntradaTipoPdf = function EntradaTipoPdf(_ref) {
  var titulo = _ref.titulo,
      clase = _ref.clase,
      pdf = _ref.pdf; // return <a className={clase} href={ pdf } dangerouslySetInnerHTML={{__html: titulo}} target="_blank" rel="noopener noreferrer" />

  if (window.electronContext && window.mostrarPDF) {
    // si estamos en electron y existe la función mostrarPDF en index.html
    return React.createElement('a', {
      onClick: function onClick() {
        return window.mostrarPDF(pdf);
      },
      className: clase,
      dangerouslySetInnerHTML: {
        __html: titulo
      },
      rel: 'noopener noreferrer'
    });
  } else if (window.parent.electronContext && window.parent.mostrarPDF) {
    // si estamos en electron, index.html está cargado en un i-frame y existe la función mostrarPDF en el fichero de carga
    return React.createElement('a', {
      onClick: function onClick() {
        return window.parent.mostrarPDF(pdf);
      },
      className: clase,
      dangerouslySetInnerHTML: {
        __html: titulo
      },
      rel: 'noopener noreferrer'
    });
  } else if (window.electronContext && !window.mostrarPDF) {
    // si estamos en electron y NO existe la función mostrarPDF en index.html
    return React.createElement('a', {
      className: clase,
      href: pdf,
      dangerouslySetInnerHTML: {
        __html: titulo
      },
      rel: 'noopener noreferrer'
    });
  } else {
    // --> navegador
    return React.createElement('a', {
      className: clase,
      href: pdf,
      dangerouslySetInnerHTML: {
        __html: titulo
      },
      target: '_blank',
      rel: 'noopener noreferrer'
    });
  }
};

EntradaTipoPdf.propTypes = process.env.NODE_ENV !== "production" ? {
  titulo: t.string,
  clase: t.string,
  pdf: t.string.isRequired
} : {};
export default EntradaTipoPdf;